import styled from 'styled-components'
import { Heading } from 'ui/elements/Heading/styles'
import { ContentBox } from 'widgets/ContentBox/styles'

export const ProgramEntry = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;

  ${ContentBox} {
    padding-top: 15px;
    margin: auto 0 15px;
  }
`

export const ProgramEntryHeader = styled.header`
  position: relative;
  margin: 0 0 auto;

  ${Heading} {
    margin: 15px 0 0;

    a {
      :before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;

        height: 100%;
        width: 100%;
      }
    }
  }
`

export const ProgramEntryFooter = styled.footer`
  margin: 0;
`
